module.exports = __webpack_public_path__ + "img/logo.c318826d.png";